import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL, VELA_QUEUE_LIMIT } from './constants';
import type { VelaQueueItem } from './types';

async function fetchVelaQueue(limit: number): Promise<VelaQueueItem[]> {
  const token = localStorage.getItem('token') || '';
  try {
    const res = await axios.get<VelaQueueItem[]>(
      API_URL + '/vela/queue/?limit=' + limit,
      { headers: { Authorization: 'Bearer ' + token } }
    );
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

export function useVelaQueue(limit: number = VELA_QUEUE_LIMIT) {
  return useQuery({
    queryKey: ['vela-queue', limit],
    queryFn: () => fetchVelaQueue(limit),
    staleTime: 30_000,
    placeholderData: [] as VelaQueueItem[],
  });
}
